// "Kopetz S et al." — how an article states its authorship everywhere it is
// cited. Every surface that cites an article renders it the same way, cards and
// non-UI modules alike, so it lives here and not in a card: importing a card
// module loads its hooks, analytics and i18n.
// `authors` holds the co-authors: the ingestion takes the first author out of
// it into `primary`, so `authors[0]` is the SECOND author when `primary` is set.
// About 1% of stored works (older writers) still repeat `primary` inside
// `authors`, so a co-author is any name other than the first one.
export function authorLine(
  primary: string | null,
  authors: ReadonlyArray<string>
): string {
  const first = primary === null ? authors[0] : primary;
  if (first === undefined) return "";
  return authors.some((author) => author !== first) ? `${first} et al.` : first;
}
